import { useRef, useState } from "react";
import Webcam from "react-webcam";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "./KycStyles.css";

const videoConstraints = {
  facingMode: { exact: "user" },
};

export default function SelfieCapture() {
  const webcamRef = useRef(null);
  const navigate = useNavigate();
  const { token } = useParams();
  const location = useLocation();
  const [capturing, setCapturing] = useState(false);

  const capture = () => {
    setCapturing(true);
    const imageSrc = webcamRef.current.getScreenshot();
    navigate(`/${token}/selfie-confirm`, { state: { ...location.state, image: imageSrc } });
  };

  return (
    <div className="kyc-container">
      <div className="kyc-progress">
        <div className="kyc-progress-bar" style={{ width: "16.6%" }} />
      </div>
      <h2 className="kyc-title">Selfie Verification</h2>
      <p className="kyc-desc">
        Hold your phone at eye level and look directly into the camera. When
        ready, tap the button to take a selfie.
      </p>
      <div className="kyc-webcam-wrapper">
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={videoConstraints}
          className="kyc-webcam"
        />
        <div className="kyc-face-frame" />
      </div>
      <button
        className="kyc-capture-btn"
        onClick={capture}
        disabled={capturing}
      >
        {capturing ? "Processing..." : "Capture Selfie"}
      </button>
    </div>
  );
}
